import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Dashboard } from './telas/Dashboard.js';
import { FilaAprovacao } from './telas/FilaAprovacao.js';
import { Calculo } from './telas/Calculo.js';
import { Relatorios } from './telas/Relatorios.js';
import { Cadastros } from './telas/Cadastros.js';
import { Transmissao } from './telas/Transmissao.js';

const clienteConsulta = new QueryClient({
  defaultOptions: {
    queries: {
      // Folha não muda sozinha: refetch automático só confunde quem confere.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

type Secao = 'dashboard' | 'aprovacao' | 'calculo' | 'transmissao' | 'relatorios' | 'cadastros';

const SECOES: Array<{ id: Secao; nome: string; atalho: string }> = [
  { id: 'dashboard', nome: 'Dashboard', atalho: '1' },
  { id: 'aprovacao', nome: 'Fila de aprovação', atalho: '2' },
  { id: 'calculo', nome: 'Cálculo', atalho: '3' },
  { id: 'transmissao', nome: 'Transmissão', atalho: '4' },
  { id: 'relatorios', nome: 'Relatórios', atalho: '5' },
  { id: 'cadastros', nome: 'Cadastros', atalho: '6' },
];

function competenciaAtual(): string {
  const agora = new Date();
  return `${agora.getFullYear()}-${String(agora.getMonth() + 1).padStart(2, '0')}`;
}

function competenciaAnterior(competencia: string): string {
  const [ano, mes] = competencia.split('-').map(Number);
  if (!ano || !mes) return competencia;
  return mes === 1 ? `${ano - 1}-12` : `${ano}-${String(mes - 1).padStart(2, '0')}`;
}

export function App() {
  const [secao, setSecao] = useState<Secao>('dashboard');
  const [competencia, setCompetencia] = useState(competenciaAtual());

  return (
    <QueryClientProvider client={clienteConsulta}>
      <div className="app">
        <aside className="menu nao-imprimir">
          <div className="menu__marca">
            <strong>Via Folha</strong>
            <span className="sutil">painel do escritório</span>
          </div>

          <label className="menu__competencia">
            Competência
            <input
              type="month"
              value={competencia}
              onChange={(e) => setCompetencia(e.target.value)}
            />
          </label>

          <nav>
            {SECOES.map((s) => (
              <button
                key={s.id}
                type="button"
                className={`menu__item ${secao === s.id ? 'menu__item--ativo' : ''}`}
                onClick={() => setSecao(s.id)}
              >
                {s.nome}
                <kbd>{s.atalho}</kbd>
              </button>
            ))}
          </nav>

          <footer className="menu__rodape sutil">
            <p>Ambiente: produção restrita</p>
            <p>Nenhum evento é transmitido para produção real.</p>
          </footer>
        </aside>

        <main className="conteudo">
          {secao === 'dashboard' ? <Dashboard competencia={competencia} /> : null}
          {secao === 'aprovacao' ? (
            <FilaAprovacao competenciaAnterior={competenciaAnterior(competencia)} />
          ) : null}
          {secao === 'calculo' ? <Calculo competencia={competencia} /> : null}
          {secao === 'transmissao' ? <Transmissao competencia={competencia} /> : null}
          {secao === 'relatorios' ? <Relatorios competencia={competencia} /> : null}
          {secao === 'cadastros' ? <Cadastros /> : null}
        </main>
      </div>
    </QueryClientProvider>
  );
}
